import SimpleBar from "simplebar-react";
import "simplebar/dist/simplebar.min.css";
import "./scrollContent.css";

import React from "react";

const ScrollContent = ({ maxHeight = null, mr = null  ,children }) => {
  return (
    <div style={{ height: maxHeight ?  maxHeight : "100%", marginRight : -mr  }}>
      <SimpleBar autoHide={false} style={{ maxHeight: maxHeight || "100%", paddingRight : mr }}>
        <div>{children}</div>
      </SimpleBar>
    </div>
  );
};
 
export default ScrollContent;
